import {req, reqJson} from './axiosFun';

/**
 * 轮播图片管理
 **/
// 获取列表
export const bannerList = (params) => {
  var url = "/api/banner/list?1=1"
  if (params.type != null && params.type != '') {
    url += "&type=" + params.type;
  }
  if (params.schoolId != null) {
    url += "&schoolId=" + params.schoolId;
  }
  return reqJson("get", url)
};
//轮播图保存
export const bannerSave = (params) => {
  return reqJson("post", "/api/banner/save", params)
};
//轮播图编辑
export const bannerUpdate = (params) => {
  return reqJson("post", "/api/banner/update", params)
};
//轮播图删除
export const bannerDelete = (params) => {
  return reqJson("post", "/api/banner/delete/" + params.id)
};



// WEBPACK FOOTER //
// ./src/api/bannerMG.js